import { Component, Input } from '@angular/core';
import { IOptionItem } from '../interfaces/option-item.interface';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss']
})
export class ChecklistComponent {
  @Input() list: IOptionItem[] = [];
  @Input() selectedIDs: string[] = [];

  optionChanged(option: string): void {
    const index = this.selectedIDs?.indexOf(option);
    if (index > -1) {
      this.selectedIDs.splice(index, 1);
    } else {
      this.selectedIDs.push(option);
    }
  }

  isSelected(clickedItem: string): boolean {
    return this.selectedIDs?.indexOf(clickedItem) > -1;
  }

}
